/* eslint-disable vue/multi-word-component-names */
import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeLayout from '../layouts/View.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeLayout,
    redirect: { name: 'Anúncios' },
    children: [
      {
        path: '/anuncios',
        name: 'Anúncios',
        component: () => import('../views/Anuncios.vue')
      },
      {

        path: '/meus-anuncios',
        name: 'Meus Anúncios',
        component: () => import('../views/MeusAnuncios.vue')
      },
      {
        path: '/componentes',
        name: 'Componentes',
        component: () => import('../views/Componentes.vue')
      },
      {
        path: '/arquivos',
        name: 'Arquivos',
        component: () => import('../views/Arquivos.vue')
      },
      {
        path: '/pacotes',
        name: 'Pacotes',
        component: () => import('../views/Pacotes.vue')
      },
      {
        path: '/forum',
        name: 'Fórum',
        component: () => import('../views/Forum.vue')
      },
      {
        path: '/confirmar-compra/:id',
        name: 'Confirmar Compra',
        component: () => import('../views/ConfirmarCompra.vue')
      },
    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
